@if (tooltipMessage || autoTooltip) {
    <span
        appTooltip
        trigger="hover"
        [componentData]="tooltipMessage ?? (displayValue | translate: translationParams)"
        position="top"
        [showDelay]="200"
        [hideDelay]="200"
    >
        {{ displayValue | translate: translationParams }}
    </span>
} @else {
    {{ displayValue | translate: translationParams }}
}
